import React from 'react';
import Spinner, { SPINNER_SIZES } from 'shared/components/andtComponents/Spinner';
import SwitchButton from 'shared/components/andtComponents/Switch';
import useRoles from 'users/new-user-management/hooks/reactQuery/useRoles';
import { PERMISSION_TYPES } from 'users/containers/Organization/consts';
import { getNewCategoryPermissions } from 'users/containers/Organization/components/EffectivePermissions/effectivePremissionsUtils';

import styles from 'users/containers/Organization/components/EffectivePermissions/EffectivePermissions.module.scss';

const ActionForAllCategoriesPermissions = ({
  action,
  actionPermissionForAllCategoriesChanged,
  roleId,
  isViewOnly,
  allRolePermissions,
  allCategoriesPermissions,
  availableCategoryActions,
}) => {
  const { setRolePermissions } = useRoles();

  const actionPermissionForAllCategoriesChangeHandler = (categoriesNewPermissions) => {
    setRolePermissions.mutate({
      roleId: roleId,
      roleCategoryPermissions: categoriesNewPermissions,
    });
  };

  const onActionForAllCategoriesPermissionChangeHandler = (isChecked, actionId) => {
    const categoriesNewPermissions = [];
    allCategoriesPermissions?.forEach((categoryPermissions) => {
      const isActionAvailableForCategory = availableCategoryActions
        ?.find((item) => item.category === categoryPermissions.category)
        ?.actions.includes(actionId);
      if (isActionAvailableForCategory) {
        const actionPermission = categoryPermissions.actionPermissions.find((ap) => ap.action === actionId);

        // FULL permissions, inherited from another role - cannot be changed
        const isActionInheritedForSelection = actionPermission?.permissions.some(
          (p) => p.permissionType === PERMISSION_TYPES.FULL.id && p.derivedFromRole && p.derivedFromRole?.id !== null,
        );

        if (!isActionInheritedForSelection) {
          const categoryNewPermissions = getNewCategoryPermissions(
            allRolePermissions,
            categoryPermissions,
            actionId,
            isChecked,
          );
          categoriesNewPermissions.push(categoryNewPermissions);
        }
      }
    });
    if (actionPermissionForAllCategoriesChanged) {
      actionPermissionForAllCategoriesChanged(categoriesNewPermissions);
    } else {
      actionPermissionForAllCategoriesChangeHandler(categoriesNewPermissions);
    }
  };

  const isActionCheckboxChecked = (actionId) => {
    let isChecked = false;
    if (allCategoriesPermissions) {
      isChecked = allCategoriesPermissions.every((category) => {
        const viewPermission = category.actionPermissions.find((ap) => ap.action === actionId);
        return (
          viewPermission?.permissions.some((p) => p.permissionType === PERMISSION_TYPES.FULL.id) ||
          // If undefined, this means that the category doesn't have permission for this action,
          // and thus it is ok to ignore it when calculating if all the checkboxes are checked
          typeof viewPermission === 'undefined'
        );
      });
    }
    return isChecked;
  };

  return setRolePermissions.isPending ? (
    <div className="position-relative ps-4">
      <Spinner size={SPINNER_SIZES.SMALL} />
    </div>
  ) : (
    <SwitchButton
      isDisabled={isViewOnly}
      onChange={() => onActionForAllCategoriesPermissionChangeHandler(!isActionCheckboxChecked(action.id), action.id)}
      isChecked={isActionCheckboxChecked(action.id)}
      className={styles.permissionSwitch}
      isSmall
    />
  );
};


export default ActionForAllCategoriesPermissions;
